<template>
  <div v-if="labels_data !== undefined && labels_data.length != 0">
    <b-card no-body class="border">
      <b-card-body>
        <b-row>
          <b-col xl="12">
            <vue-apex-charts ref="barChart" style="direction:ltr" type="bar" :height="chartHeight(labels_data.length)"
              :options="apexChatData" :series="barSeries" :labels_data="labels_data" />
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
    <list-modal ref="mainListModal" />
    <list-modal ref="subListModal" />
  </div>
</template>

<script>

import { $themeColors } from '@themeConfig'

import {
  BCard,
  BCardBody,
  BCardHeader,
  BCardTitle,
  BCardSubTitle,
  BBadge,
  BRow,
  BCol,
  BContainer,
  BButton
} from 'bootstrap-vue'

import { ref, computed } from '@vue/composition-api'

import VueApexCharts from 'vue-apexcharts'
import { OrbitSpinner } from 'epic-spinners'
import TableWidget from '@/views/dashboard/modals/TableWidget.vue';

import ListModal from '../../modals/ListModal.vue'
import axios from '@/libs/axios'
import store from '@/store'
export default {

  props: ['listData', 'barSeries', 'labels_data'],
  components: {
    VueApexCharts,
    BCardHeader,
    BCard,
    BBadge,
    BCardBody,
    BCardTitle,
    BCardSubTitle,
    BRow,
    BCol,
    BContainer,
    BButton,
    OrbitSpinner,
    TableWidget,
    ListModal
  },

  setup(props, { root }) {

    const mainListModal = ref(null)
    const subListModal = ref(null)

    const chartHeight = (count) => {
      if (count <= 2) {
        return 400;
      }
      return count * 100;
    }

    const wordSize = (word) => {
      if (word.length < 15)
        return 1;
      return 2;
    }

    const breakWords = (array) => {

      let out = []
      array.forEach((item, index) => {

        let s = item.value
        console.log(s)
        var result = [];

        var words = s.split(" ");
        var row = [];
        for (var i = 0; i < words.length; ++i) {
          if (row.reduce((s, w) => s + wordSize(w), 0) + wordSize(words[i]) >= 4) {
            result.push(row);
            row = [];
          }
          row.push(words[i]);
        }
        result.push(row);

        result = result.map(a => a.join(" "))

        array[index] = result;
      })

      return array
    }


    const apexChatData = {
      style: {
        diraction: 'ltr'
      },
      legend: {
        show: true,
        position: 'top',
        fontSize: '0.5rem',
        fontFamily: 'Montserrat',
        customLegendItems: [root.$i18n.t('Planned'), root.$i18n.t('Served'), root.$i18n.t('Not Served')]
      },
      chart: {
        events: {
          dataPointSelection: (event, chartContext, config) => {
            mainListModal.value.showModal({
              list: props.listData[config.dataPointIndex],
              title: props.labels_data[config.dataPointIndex],
              fields: [
                {
                  key: 'device_name',
                  label: 'device'
                },
                {
                  key: 'geofence_name',
                  label: 'area'
                },
                {
                  key: 'planned',
                  label: 'Planned'
                },
                {
                  key: 'served',
                  label: 'Served'
                },
                {
                  key: 'notServed',
                  label: 'Not Served'
                }
              ]
            })
          }
        },
        zoom: {
          enabled: false,
        },
        toolbar: {
          show: false,
        },
      },
      markers: {
        strokeWidth: 2,
        strokeOpacity: 1,
        strokeColors: [$themeColors.light],
        colors: [$themeColors.light],
      },
      colors: ['#D6D5D5', '#04d600', '#d61002'],
      plotOptions: {
      },
      dataLabels: {
        enabled: true,
        position: 'top',
        style: {
          fontSize: "10px",
          fontFamily: "Helvetica, Arial, sans-serif",
          fontWeight: "bold"
        },
        formatter: function (val, opt) {
          if ([1, 2].includes(opt.seriesIndex)) {
            return `${val} (${Math.round((val / props.barSeries[0].data[opt.dataPointIndex]) * 100)}%)`
          }
          return val
        },


      },
      stroke: {
        curve: 'straight',
      },
      grid: {
        xaxis: {
          lines: {
            show: true,
          },
        },
      },
      tooltip: {
        custom(data) {
          return `${'<div class="px-1 py-50"><span>'}${data.series[data.seriesIndex][data.dataPointIndex]
            }</span></div>`
        },
      },
      xaxis: {
        categories: [],
        opposite: true,
        labels: {
          show: true,
          trim: true,
        }
      },
      yaxis: {
        labels: {
          show: true,
          trim: true,
          style: {
            colors: [],
            fontSize: '12px',
            minWidth: '500px !important',
            fontFamily: 'Helvetica, Arial, sans-serif',
            fontWeight: 'bold',
            cssClass: 'apexcharts-xaxis-label',
          },

        }

      },
    }


    return {
      chartHeight,
      apexChatData,
      breakWords,
      wordSize,
      mainListModal,
      subListModal
    }
  },
  updated: function () {
    if (this.$refs.barChart != undefined) {
      this.$refs.barChart.updateOptions({
        xaxis: {
          categories: this.labels_data.length > 0 ? this.labels_data : []
        },
        legend: {
          customLegendItems: [this.$t('Planned'), this.$t('Served'), this.$t('Not Served')]
        }
      })
    }
  }
}
</script>


<style scoped>
.apexcharts-canvas {

  direction: ltr !important;
}

.apexcharts-datalabel {
  font-family: "Montserrat", Helvetica, Arial, serif !important;
  fill: #6e6b7b;
  font-weight: 700 !important;
}
</style>
